<template>
  <b-row class="pl-2 pr-4">
    <b-col cols="12" class="d-flex align-items-center justify-content-between">
      <PageTitle title="Cadastro pixel do Facebook" />
    </b-col>

    <b-col cols="6 mt-4">
      <label>Pixel para o App</label>
      <input type="text" class="form-control" v-model="pixel_app" placeholder="##############">
    </b-col>

    <b-col cols="6 mt-4">
      <label>Pixel para o Site</label>
      <input type="text" class="form-control" v-model="pixel_site" placeholder="##############">
    </b-col>

    <b-col cols="12 text-center mt-4 mb-4" v-if="whatClerkPermission()">
      <button class="btn btn-success pr-5 pl-5" @click="atualizarPixelId()">Salvar pixel</button>
    </b-col>

  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import NamePermission from '@/enums/Clerk/NamePermission';
import TypePermission from '@/enums/Clerk/TypePermission';

export default {
  name: 'PixelFacebook',
  mixins: [makeToast],

  components: {
    PageTitle
  },

  data() {
    return {
      pixel_app: '',
      pixel_site: ''
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.listPixelId();
  },

  methods: {   
    listPixelId() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getPixelId', this.userTypeId())
        .then((response) => {
          if(response.data.pixel_app) {
            this.pixel_app = response.data.pixel_app;
            this.pixel_site = response.data.pixel_site;
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao trazer os dados!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    atualizarPixelId() {
      const data = {
        construp_user_id: this.userTypeId(),
        pixel_app: this.pixel_app,
        pixel_site: this.pixel_site
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/atualizarPixelId', data)
        .then((response) => {
          if(response.data.error == true) {
            this.makeToast('Opss', 'Houve um erro ao atualizar o pixel!', 'danger');
          } else {
            this.makeToast('Sucesso', 'Pixel atualizado com sucesso!', 'success');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao atualizar o pixel!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    userTypeId(){
      return this.$route.meta.userType == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.PIXEL_FACEBOOK);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>

</style>